import PropTypes from 'prop-types';

const ALLOWED_ADDRESS_FIELDS = ['zipcode', 'street', 'neighborhood', 'city', 'state', 'complement', 'number'];

/**
 * Sanitize an address object by keeping only the standard fields.
 * This prevents server-side schema errors caused by internal IDs
 * (city_id, state_id, neighborhood_id) that APIs sometimes inject.
 */
export const sanitizeAddress = (address = {}) =>
  ALLOWED_ADDRESS_FIELDS.reduce((acc, key) => {
    acc[key] = address[key] !== undefined ? address[key] : '';
    return acc;
  }, {});

sanitizeAddress.propTypes = {
  address: PropTypes.object,
};
